import { render } from "./Dashboard-tap.vue?vue&type=template&id=df55cf48"
import script from "./Dashboard-tap.vue?vue&type=script&lang=js"
export * from "./Dashboard-tap.vue?vue&type=script&lang=js"

import "./Dashboard-tap.vue?vue&type=style&index=0&id=df55cf48&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__